export default __webpack_public_path__ + "static/media/pasajeros.41d5ca84.png";